exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notificationIconComponent-notificationIconContainer{display:flex}.notificationIconComponent-notificationBadge{color:var(--text)}.notificationIconComponent-notificationIcon{color:var(--text);padding-right:8px;padding-bottom:5px}.notificationIconComponent-redirectLink{text-decoration:none;color:var(--text);padding:0}\n", ""]);

// exports
